import React from "react";
import { useTranslation } from "react-i18next";

const FunctionBanner = (props) => {

  const { t } = useTranslation();

  return (
    <div className={"is-banner"}>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', padding: '0px 48px' }}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          height: '73px', width: '100%',
          alignItems: 'center'
        }}>
          {props.children}
        </div>
      </div>
    </div>
  );
}

FunctionBanner.propTypes = {
};

export default FunctionBanner;